import App from '../index.js';

App.Organizations = (function () {

    let datatable,
        elDatatable = $('#organizations_table');

    function initDataTable () {
        if(!elDatatable[0]) return;

        let options = {
            destroy: true,
            serverSide: true,
            processing: true,
            searching: true,
            deferRender: true,
            stateSave: false,
            pageLength: 50,
            lengthChange: false,
            language: {
                searchPlaceholder: "Search",
                search: "",
            },
            layout: {
                topStart: { div: { className: 'table-headline' } },
                topEnd: 'search',
                bottomStart: 'info',
                bottomEnd: 'paging',
            },
            initComplete: function () {
                $('#organizations_table_holder .table-headline').html($('#organizations_table_headline').html());
                $('#organizations_table_holder .dt-search [type="search"]').removeClass('form-control-sm').closest('label').addClass('form-group search-box').prepend('<i class="search-icon fas fa-search"></i>');
                $('#organizations_table_holder .dt-search .form-group, #organizations_table_holder .dt-search .search-box').wrapAll('<div class="form-row justify-content-end align-items-center text-end"></div>');

            },
            order: [[ 0, "desc" ]],
            ajax: {
                url: elDatatable.data('query-url'),
                type: "POST",
                data: function (d) {
                    d._token = $('meta[name="csrf-token"]').attr('content');
                }
            },
            columns: [
                {
                    data: 'name',
                    orderable: false,
                    className: 'datatable-date'
                },
                {
                    data: 'action',
                    orderable: false,
                    searchable: false,
                    className: 'datatable-action'
                }
            ]
        };

        datatable = elDatatable.DataTable(options);
    }

    return {
        init: function(){
            initDataTable();
            App.dataTableTypeDelay($('.dt-container .dt-search input[type="search"]'));

            $('body').on('click', '.delete-organization', function () {
                let name = $(this).data('organization-name');
                let route = $(this).data('url');
                $('#deleteOrganization form').attr('action', route);
                $('#deleteOrganization .header-sub-text').html(`Are you sure you want to delete organization ${name}? <br/><br/>Type (<strong>${name}</strong>) to confirm.`);
            });

            $('#deleteUser').on('hide.bs.modal', function () {
                $('.header-sub-text').empty();
            });
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.index', App.Organizations.init);

export default App.Organizations;
